import ApplicationCallbacksProvider, { useApplicationCallbacks } from './ui/ApplicationCallbacksProvider';

export default ApplicationCallbacksProvider;

export { useApplicationCallbacks };
